import { Component } from '@angular/core';
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { MinutesMeetingPresencePipe } from "@shared/pipes/minutesMeetingPresencePipe";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { MinutesMeetingPresence } from "@models/documents/document-enums";
import { DocumentStatusEnum } from "@models/documents/document-status.enum";
import { Attendee } from "@models/documents/attendee";

type ActionEvent = (data: Attendee | undefined) => void;

type CellRendererParams = ICellRendererParams<Attendee> & {
  onSelectDirectorMeetingStatus: ActionEvent,
};

@Component({
  selector: 'app-ag-director-meeting-status',
  standalone: true,
  imports: [
    MinutesMeetingPresencePipe,
    NgbDropdown,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdownToggle,
  ],
  templateUrl: './ag-director-meeting-status.component.html',
  styleUrl: './ag-director-meeting-status.component.scss'
})
export class AgDirectorMeetingStatusComponent implements ICellRendererAngularComp {
  protected params!: CellRendererParams;
  status: MinutesMeetingPresence | undefined;
  MinutesMeetingPresence = MinutesMeetingPresence;
  selectOptions = Object.values(MinutesMeetingPresence)
    .map(v => v)
    .filter(item => typeof item === 'number') as number[];

  agInit(params: CellRendererParams): void {
    this.params = params;
    this.status = params.value as MinutesMeetingPresence | undefined;
  }

  refresh(params: CellRendererParams): boolean {
    this.params = params;
    this.status = params.value as MinutesMeetingPresence | undefined;
    return true;
  }

  onSelectDirectorMeetingStatus(status: MinutesMeetingPresence | undefined): void {
    if (this.params.data) {
      this.params.data.presence = status;
      this.status = status;
      this.params.onSelectDirectorMeetingStatus(this.params.data);
    }
  }

  protected readonly DocumentStatusEnum = DocumentStatusEnum;
}
